import { Injectable } from '@angular/core';
import { Option } from '../../../../campaña/components/campana-select/campana-select-component';
import { AnalysisMode, DemographicKey } from '../reporte-filtros.component';

export interface ReportFiltersState {
  filters: { [key in DemographicKey]?: Option };
  groupBy: DemographicKey[];
  analysisMode?: AnalysisMode;
}

interface StoredState extends ReportFiltersState {
  campaignId: string;
}

@Injectable({
  providedIn: 'root'
})
export class ReportFiltersStateService {
  private state: StoredState | null = null;

  getState(campaignId: string): ReportFiltersState | null {
    if (!this.state || this.state.campaignId !== campaignId) {
      return null;
    }
    return JSON.parse(JSON.stringify(this.state));
  }

  setState(campaignId: string, state: ReportFiltersState): void {
    this.state = {
      campaignId,
      filters: { ...state.filters },
      groupBy: [...state.groupBy],
      ...(state.analysisMode ? { analysisMode: state.analysisMode } : {}),
    };
  }

  clearState(): void {
    this.state = null;
  }
}
